import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React, { useContext, useRef } from 'react';
import PropTypes from "prop-types";
import Icon from "../feather-icon/Icon";
import Flex from "noood/comp/ui/containers/Flex";
import { RandomStringGenerator } from "noood/util/rand/RandomStringGenerator";
import { ClosestElementRegistryContext } from "noood/contexts/contexts";
import * as stylex from "@stylexjs/stylex";
export default function PageTitle(props) {
  var closestCtx = useContext(ClosestElementRegistryContext);
  var thisRef = useRef();
  var id = RandomStringGenerator.alphanum(10);
  return /*#__PURE__*/React.createElement("div", stylex.props(ui.base, (props.leftControl || props.rightControl) && ui.has_controls), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      left: "8px",
      display: "flex"
    }
  }, props.leftControl), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      width: "".concat(props.leftControl || props.rightControl ? "80%" : "")
    },
    className: ['content-ctrl-center'].join(' ')
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 5,
    id: id
  }, props.icon && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    size: props.icon_size
  })), /*#__PURE__*/React.createElement(Flex, {
    isHorizontal: false
  }, /*#__PURE__*/React.createElement("div", {
    className: [props.is_title ? 'text-R' : ''].join(' ')
  }, props.title), props.subtitle && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary text-S"
  }, props.subtitle)))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      right: "8px"
    }
  }, props.rightControl));
}
PageTitle.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element]),
  icon: PropTypes.string,
  icon_size: PropTypes.number,
  is_title: PropTypes.bool,
  // consider the Edit of Delete link buttons
  rightControl: PropTypes.any,
  leftControl: PropTypes.any,
  subtitle: PropTypes.any
  // should we align left, center, or right?
  ,

  flush: PropTypes.string
};
PageTitle.defaultProps = {
  is_title: true,
  icon_size: 15
};

// @ts-ignore
_inject(".ev7z7khe{padding:10px}", 1000);
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev1qughib{justify-content:space-between}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evz7ivw7{border-bottom:1px solid var(--shade-10)}", 2000);
_inject(".evl56j7k{justify-content:center}", 3000);
var ui = {
  base: {
    "PageTitle__ui.base": "PageTitle__ui.base",
    padding: "ev7z7khe",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    display: "ev78zum5",
    justifyContent: "ev1qughib",
    alignItems: "ev6s0dn4",
    borderBottom: "evz7ivw7",
    borderBottomWidth: null,
    borderBottomStyle: null,
    borderBottomColor: null,
    $$css: true
  },
  has_controls: {
    "PageTitle__ui.has_controls": "PageTitle__ui.has_controls",
    justifyContent: "evl56j7k",
    $$css: true
  }
};